<div class="info-card mb-4">
  <div class="card-header">
    <span class="card-title mb-0"> {{ title }} </span>

    <button
      mat-raised-button
      matTooltip="Limit 10,000"
      matTooltipPosition="above"
      [disabled]="fileLoading"
      (click)="downloadData()"
    >
      <span class="button-label-with-icon">
        @if (fileLoading) {
          <mat-spinner diameter="20" />
        } @else {
          <mat-icon class="me-2">cloud_download</mat-icon>
        }
        Download Excel File
      </span>
    </button>
  </div>

  <div class="card-info">
    <kendo-grid
      #usageGrid="kendoGrid"
      class="w-100"
      [data]="gridData"
      [pageable]="true"
      [skip]="skip * 1"
      [pageSize]="take"
      [columnMenu]="{ columnChooser: false }"
      [height]="300"
      [size]="'small'"
      (dataStateChange)="dataStateChange($event)"
    >
      <kendo-grid-column width="75">
        <ng-template let-dataItem kendoGridCellTemplate>
          <button
            mat-icon-button
            color="primary"
            matTooltip="View Policy"
            (click)="handleRowClick(dataItem)"
          >
            <mat-icon>preview</mat-icon>
          </button>
        </ng-template>
      </kendo-grid-column>
      @for (header of gridData.headers; track $index) {
        <kendo-grid-column
          [field]="header.DataField"
          [title]="header.Label"
          [sortable]="header.Sort"
          [filterable]="header.Filter"
          [hidden]="header.Hidden"
        >
          <ng-template let-dataItem kendoGridCellTemplate>
            @if (header['Type'] === 'curr') {
              {{ dataItem[header.DataField] | currency }}
            } @else if (header['Type'] === 'double') {
              {{ dataItem[header.DataField] | number }}
            } @else {
              {{ dataItem[header.DataField] }}
            }
          </ng-template>
        </kendo-grid-column>
      }
      <ng-template
        let-totalPages="totalPages"
        let-currentPage="currentPage"
        kendoPagerTemplate
      >
        <kendo-pager-prev-buttons />
        <kendo-pager-numeric-buttons [buttonCount]="5" />
        <kendo-pager-next-buttons />
        <kendo-pager-input />
        <kendo-pager-info />
        <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
      </ng-template>
    </kendo-grid>

    <ngx-loading
      [show]="loading"
      [config]="{
        fullScreenBackdrop: false,
      }"
    />
  </div>
</div>
